import { arrayOfJobTypes, jobType } from "~/schemas/schema.job_types.jsx";
import {
  FETCH_USER_JOB_TYPES_ERROR,
  FETCH_USER_JOB_TYPES_SUCCESS,
  FETCH_USER_JOB_TYPES_LOADING,
  FETCH_JOB_TYPES_LOADING,
  FETCH_JOB_TYPES_SUCCESS,
  FETCH_JOB_TYPES_ERROR,
  ADD_JOB_TYPE_SUCCESS,
  ADD_JOB_TYPE_LOADING,
  ADD_JOB_TYPE_ERROR,
  EDIT_JOB_TYPE_LOADING,
  EDIT_JOB_TYPE_SUCCESS,
  EDIT_JOB_TYPE_ERROR,
  DELETE_JOB_TYPE_LOADING,
  DELETE_JOB_TYPE_SUCCESS,
  DELETE_JOB_TYPE_ERROR,
  FETCH_JOB_TYPE_LOADING,
  FETCH_JOB_TYPE_SUCCESS,
  FETCH_JOB_TYPE_ERROR,
  DELETE_JOB_TYPE_FROM_EVENT_STREAM,
  SET_BATCH_JOB_TYPES_LOADING,
  SET_BATCH_JOB_TYPES_SUCCESS,
  SET_BATCH_JOB_TYPES_ERROR,
} from "~/store/action_types";
import Angie from "~/utils/angie.jsx";
import { fetch } from "~/utils/fetch.jsx";

export const fetchUserJobTypes = (userId) => {
  return {
    types: [FETCH_USER_JOB_TYPES_LOADING, FETCH_USER_JOB_TYPES_SUCCESS, FETCH_USER_JOB_TYPES_ERROR],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/users/${userId}/job-types`,
      }),
    payload: {
      userId,
      schema: arrayOfJobTypes,
    },
  };
};

export const fetchJobType = (id) => {
  return {
    types: [FETCH_JOB_TYPE_LOADING, FETCH_JOB_TYPE_SUCCESS, FETCH_JOB_TYPE_ERROR],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/job-types/${id}`,
      }),
    payload: {
      id,
      schema: {
        single: jobType,
      },
    },
  };
};

export const fetchJobTypesAction = () => ({
  types: [FETCH_JOB_TYPES_LOADING, FETCH_JOB_TYPES_SUCCESS, FETCH_JOB_TYPES_ERROR],
  callAPI: () =>
    fetch({
      url: `${Angie.api_url}/job-types`,
    }),
  payload: {
    schema: arrayOfJobTypes,
  },
});

export const addJobTypeAction = (attributes) => ({
  types: [ADD_JOB_TYPE_LOADING, ADD_JOB_TYPE_SUCCESS, ADD_JOB_TYPE_ERROR],
  callAPI: () =>
    fetch({
      url: `${Angie.api_url}/job-types`,
      method: "POST",
      body: attributes,
    }),
  payload: {
    attributes,
    schema: {
      single: jobType,
    },
  },
});

export const editJobTypeAction = (id, attributes) => ({
  types: [EDIT_JOB_TYPE_LOADING, EDIT_JOB_TYPE_SUCCESS, EDIT_JOB_TYPE_ERROR],
  callAPI: () =>
    fetch({
      url: `${Angie.api_url}/job-types/${id}`,
      method: "PUT",
      body: attributes,
    }),
  payload: {
    id,
    attributes,
    schema: {
      single: jobType,
    },
  },
});

export const setBatchJobTypesAction = (attributes) => ({
  types: [SET_BATCH_JOB_TYPES_LOADING, SET_BATCH_JOB_TYPES_SUCCESS, SET_BATCH_JOB_TYPES_ERROR],
  callAPI: () =>
    fetch({
      url: `${Angie.api_url}/job-types/set-batch`,
      method: "POST",
      body: attributes,
    }),
  payload: {
    attributes,
    schema: {
      created: arrayOfJobTypes,
      updated: arrayOfJobTypes,
    },
  },
});

export const deleteJobTypeAction = (id, is_in_use = true, switch_users_to_id = undefined) => ({
  types: [DELETE_JOB_TYPE_LOADING, DELETE_JOB_TYPE_SUCCESS, DELETE_JOB_TYPE_ERROR],
  callAPI: () =>
    fetch({
      url: `${Angie.api_url}/job-types/${id}`,
      method: "DELETE",
      body: { switch_users_to_id },
    }),
  payload: {
    id,
    switch_users_to_id,
    is_in_use,
  },
});

export const deleteJobTypeFromEventStream = (id) => {
  return {
    type: DELETE_JOB_TYPE_FROM_EVENT_STREAM,
    id,
  };
};
